import React, { createContext, useContext, useState } from "react";

const SharedContext = createContext(null);

export const SharedProvider = ({ children }) => {
  const [sharedState, setSharedState] = useState({});

  const setValue = React.useCallback((key, value) => {
    setSharedState((prev) => ({ ...prev, [key]: value }));
  }, []);

  const value = React.useMemo(() => ({ sharedState, setValue }), [sharedState, setValue]);

  return (
    <SharedContext.Provider value={value}>
      {children}
    </SharedContext.Provider>
  );
};

export const useShared = () => {
  const context = useContext(SharedContext);
  if (!context) throw new Error("useShared must be used within a SharedProvider");
  return context;
};
